
import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { Button } from '@/components/ui/button';
import { ProtectedRoute } from '@/components/ProtectedRoute';
import Navbar from '@/components/Navbar';
import ListingForm from '@/components/ListingForm';

const EditListing = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const { subscription, profile } = useAuth();

  // Check if user has active subscription or freemium tier
  const hasActiveAccess = subscription?.subscribed || (profile?.admin_tier && profile.admin_tier === 'freemium');

  if (!hasActiveAccess) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="max-w-md mx-auto text-center p-6 bg-white rounded-lg shadow-sm">
          <h2 className="text-xl font-semibold mb-4">Subscription Required</h2>
          <p className="text-gray-600 mb-6">
            You need an active subscription to edit listings. Please subscribe to continue.
          </p>
          <Button onClick={() => navigate('/breeder-dashboard')}>
            Go to Dashboard
          </Button>
        </div>
      </div>
    );
  }

  return (
    <ProtectedRoute requiredUserType="breeder">
      <div className="min-h-screen bg-gray-50">
        <Navbar />
        <ListingForm mode="edit" listingId={id} title="Edit Listing" />
      </div>
    </ProtectedRoute>
  );
};

export default EditListing;
